import { TableCell } from '@mui/material';
import styled from 'styled-components';

export const SubtitleTable = styled.b`
  color: gray;
  font-size: ${({ theme }) => theme.fontSize?.[theme.fontSizeType]?.fs14};
`;

export const TableCellStyle = styled(TableCell)`
  width: 20px;
`;

export const ContainerTitle = styled.div`
  padding: 5rem 1rem 1rem 16px;
`;

export const SituationRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  height: 2.5rem;
  width: 120px;
`;

export const Form = styled.div`
  padding-top: 1.5rem;
  font-size: ${({ theme }) => theme.fontSize?.['normal']?.fs14};
`;

export const Container = styled.div`
  padding: 1rem 0 2rem;

  .cell {
    padding: 1rem;
  }
`;

export const Load = styled.div`
  padding-top: 5rem;
`;
